import ZigBotStatic from '@/assets/lottie/zigbot-icon/Zigbot_Static_Icon.svg?react';
import { cn } from '@/lib/utils';

export interface ZigBotAvatarProps {
    className?: string;
}

// Static on purpose. The attention animation is `ZigBotAttentionGlow`, which plays behind this.
export const ZigBotAvatar = ({ className }: ZigBotAvatarProps) => (
    <ZigBotStatic aria-hidden="true" className={cn('size-full', className)} />
);
